import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { SupportSendMessage as SupportSendMessageFeature } from 'src/features/support/sendMessage';
import { SupportSendMessage as SupportSendMessageEntity, SupportSendMessageProps } from 'src/entities/support';

export const WriteToDirector = ({ ...props }: Omit<SupportSendMessageProps, 'leftBlockContent' | 'leftBlockTitle' | 'rightBlock'>) => {
  const isMobile = useIsMobile();

  return (
    <SupportSendMessageEntity
      leftBlockContent={
        !isMobile && (
          <>
            <Typography component="p" sx={{ typography: 'caption' }}>
              Прямая связь с директором - важнейший элемент процветания бизнеса, ориентированного на клиента. С момента основания компании
              каждый имеет возможность напрямую обратиться к руководителю.
            </Typography>
            <Typography component="p" sx={{ typography: 'caption' }}>
              Главное обещание: ни одно письмо не останется без внимания.
            </Typography>
          </>
        )
      }
      leftBlockTitle={'Отправить сообщение директору'}
      rightBlock={<SupportSendMessageFeature />}
      {...props}
    />
  );
};
